import React from "react";
import { usePageMeta } from "../hooks/usePageMeta";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SEOVillesReunion from "../components/SEOVillesReunion";
import FAQSection from "../components/FAQSection";
import StatsSection from "../components/StatsSection";
import WhyChooseSection from "../components/WhyChooseSection";

const HomePage = () => {
  usePageMeta({
    title: "Marabout Réunion 974 | Voyant Médium à La Réunion – Maître Diamma",
    description: "Marabout Réunion 974 - Maître Diamma, puissant voyant médium africain. Spécialiste du retour affectif à Saint-Denis, Saint-Pierre, Le Tampon, Saint-Paul. Consultation ☎ +33 7 45 44 96 41",
    url: "https://marabout-reunion.com/",
  });

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <Hero />
      <StatsSection />
      <Services />
      <WhyChooseSection />
      <SEOVillesReunion />
      <FAQSection />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;